import Vue from 'vue'
import axios from 'axios'

let sessionKnown = false

export function applyStaffSession (session) {
  Vue.ls.set('authenticated', session.authenticated === true)
  Vue.ls.set('fullname', session.user.fullname)
  Vue.ls.set('role', JSON.stringify(session.user.roles))
  Vue.ls.set('userid', session.user.id)
  Vue.ls.set('impersonating', session.impersonating === true)
  Vue.ls.set('originalFullname', session.actor.fullname)
  sessionKnown = true
  return session
}

export function clearStaffSession () {
  Vue.ls.remove('authenticated')
  Vue.ls.remove('role')
  Vue.ls.remove('fullname')
  Vue.ls.remove('userid')
  Vue.ls.remove('impersonating')
  Vue.ls.remove('originalFullname')
  sessionKnown = false
}

export function syncStaffSession () {
  if (sessionKnown) return Promise.resolve(true)

  return axios.get('session')
    .then(response => {
      applyStaffSession(response.data)
      return true
    })
    .catch(() => {
      clearStaffSession()
      return false
    })
}

export function stopImpersonating () {
  return axios.post('impersonation/stop', null, {emulateJSON: true})
    .then(response => applyStaffSession(response.data))
}



// WEBPACK FOOTER //
// ./src/services/staff-session.js